var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#E4EAF0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3156_10734",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 16,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3156_10734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9967 19.7667C19.1388 19.7667 18.4388 19.4956 17.8967 18.9534C17.3544 18.4112 17.0833 17.7112 17.0833 16.8533C17.0833 15.9956 17.3544 15.2945 17.8967 14.75C18.4388 14.2056 19.1388 13.9333 19.9967 13.9333C20.8544 13.9333 21.5583 14.2056 22.1083 14.75C22.6583 15.2945 22.9333 15.9956 22.9333 16.8533C22.9333 17.7112 22.6583 18.4112 22.1083 18.9534C21.5583 19.4956 20.8544 19.7667 19.9967 19.7667ZM14.25 25.9667V23.9535C14.25 23.459 14.3768 23.0271 14.6305 22.658C14.8842 22.289 15.2129 22.0086 15.6167 21.8167C16.3833 21.4722 17.1248 21.2139 17.841 21.0417C18.5572 20.8695 19.2754 20.7833 19.9955 20.7833C20.7369 20.7833 21.4619 20.8722 22.1705 21.05C22.8791 21.2278 23.6107 21.4844 24.3653 21.8198C24.7866 21.9986 25.1254 22.2734 25.382 22.644C25.6384 23.0147 25.7667 23.4497 25.7667 23.9492V25.9667H14.25ZM15.8167 24.4H24.1833V24.0167C24.1833 23.8461 24.1306 23.6832 24.025 23.528C23.9194 23.3728 23.7889 23.2579 23.6333 23.1833C22.9667 22.8722 22.3528 22.6583 21.7917 22.5417C21.2307 22.425 20.6307 22.3667 19.9917 22.3667C19.375 22.3667 18.775 22.425 18.1917 22.5417C17.6083 22.6583 16.9968 22.8713 16.3572 23.1807C16.1968 23.2553 16.0667 23.3706 15.9667 23.5263C15.8667 23.682 15.8167 23.8455 15.8167 24.0167V24.4ZM19.9967 18.2C20.3878 18.2 20.7111 18.0731 20.9667 17.8192C21.2222 17.5654 21.35 17.2426 21.35 16.8507C21.35 16.4541 21.2233 16.1298 20.97 15.8778C20.7168 15.626 20.3946 15.5 20.0033 15.5C19.6122 15.5 19.2889 15.6262 19.0333 15.8787C18.7778 16.1311 18.65 16.4523 18.65 16.8423C18.65 17.2369 18.7767 17.5619 19.03 17.8172C19.2832 18.0724 19.6054 18.2 19.9967 18.2Z",
    fill: "#172128"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.172154d6432ccdc4ca106ae9153d844b.svg";
export { ForwardRef as ReactComponent };